"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments() {
    return ['BGREWRITEAOF'];
}
exports.transformArguments = transformArguments;
